import { render, staticRenderFns } from "./MyTagInput.vue?vue&type=template&id=6235f3c6&scoped=true&"
import script from "./MyTagInput.vue?vue&type=script&lang=js&"
export * from "./MyTagInput.vue?vue&type=script&lang=js&"
import style0 from "./MyTagInput.vue?vue&type=style&index=0&id=6235f3c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235f3c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6235f3c6')) {
      api.createRecord('6235f3c6', component.options)
    } else {
      api.reload('6235f3c6', component.options)
    }
    module.hot.accept("./MyTagInput.vue?vue&type=template&id=6235f3c6&scoped=true&", function () {
      api.rerender('6235f3c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyTagInput.vue"
export default component.exports